import {
    RESPONSIBLE_ORDER_KEY,
    responsibleOrderIdByKey
} from '@app/constants/RESPONSIBLES_ORDER';

/**
 * Valores por defecto compartidos por las plantillas de flujo premium precargadas
 * (`build-preconfigured-premium-flows.ts`, esqueletos Coupa / OC / TDC / híbrido).
 */

/** Sin texto de plazo (flujos OC / TDC y pasos con duration vacío en plantilla JSON). */
export const PRECONFIGURED_DEFAULT_PROCESS_DURATION_EMPTY = '';

/** Plazo no acotado en minúsculas (flujo Coupa y varios pasos). */
export const PRECONFIGURED_DEFAULT_PROCESS_DURATION_INDEFINIDO = 'indefinido';

/** Etiqueta de duración para etapa Factura (plantilla previa en JSON). */
export const PRECONFIGURED_DEFAULT_PROCESS_DURATION_INDEFINIDO_LABEL =
    'Indefinido';

/**
 * Responsable de etapa cuando el esqueleto de proceso no define `responsible`
 * (misma regla que el fallback en {@link buildOrderProcessesFromSkeleton}).
 */
export function preconfiguredDefaultProcessResponsibleId(): number {
    return responsibleOrderIdByKey(RESPONSIBLE_ORDER_KEY.MARKETING);
}

/**
 * Entrada mínima de subproceso en esqueleto; nombre y descripción se resuelven en
 * {@link buildSubprocessStructuresFromSkeleton} desde {@link PREMIUM_ORDER_ACTIONS}
 * si no se pasan aquí.
 */
export function preconfiguredSubSkeleton(
    action: number,
    position: number,
    overrides?: { name?: string; descripcion?: string }
): { action: number; position: number; name?: string; descripcion?: string } {
    return { action, position, ...overrides };
}
